module.exports = __webpack_public_path__ + "img/banistera.ccf9462a.jpg";